import { apiAuth as api, apiResponseType } from "./index";

export const getMarketplaceSales = (params = {}) =>
  api.get("/sales/marketplace", { params }) as apiResponseType;

export const createMarketplaceSale = (data: any) =>
  api.post("/sales/marketplace/store", data) as apiResponseType;